import { render, staticRenderFns } from "./BoardingChamber.vue?vue&type=template&id=ca660928"
import script from "./BoardingChamber.vue?vue&type=script&lang=js"
export * from "./BoardingChamber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports